module.exports = __webpack_public_path__ + "img/logo.84f2f5b7.svg";